import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { ProductCard, SectionHeading } from "@/components/Bits";

const CATS = [
  { slug: "all", name: "All" },
  { slug: "daily-nutrition", name: "Daily Nutrition" },
  { slug: "spirulina", name: "Spirulina" },
  { slug: "sea-buckthorn", name: "Sea Buckthorn" },
  { slug: "noni", name: "Noni" },
  { slug: "flax-oil", name: "Flax Oil" },
  { slug: "glucosamine", name: "Glucosamine" },
];

export default function Shop() {
  const { category } = useParams();
  const nav = useNavigate();
  const active = category || "all";
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/products${active !== "all" ? `?category=${active}` : ""}`).then(({ data }) => {
      // put hero product first
      data.sort((a, b) => (b.is_hero ? 1 : 0) - (a.is_hero ? 1 : 0));
      setItems(data); setLoading(false);
    });
  }, [active]);

  return (
    <div>
      <section className="max-w-7xl mx-auto px-5 md:px-8 pt-14 pb-8">
        <SectionHeading eyebrow="Shop" title="The ASURE product range" subtitle="A focused range of thoughtfully selected daily nutrition products. Introductory pricing across the range." />
      </section>
      <section className="max-w-7xl mx-auto px-5 md:px-8 pb-16">
        <div className="flex flex-wrap gap-2 mb-10">
          {CATS.map((c) => (
            <button key={c.slug} data-testid={`filter-${c.slug}`} onClick={() => nav(c.slug === "all" ? "/shop" : `/shop/${c.slug}`)}
              className={`px-4 py-2 rounded-full text-sm font-medium border transition-colors ${active === c.slug ? 'bg-asure-forest text-white border-asure-forest' : 'bg-white text-asure-text2 border-[color:var(--asure-border)] hover:border-asure-forest'}`}>
              {c.name}
            </button>
          ))}
        </div>
        {loading ? (
          <div className="text-center py-24 text-asure-text2">Loading…</div>
        ) : items.length === 0 ? (
          <div className="text-center py-24 text-asure-text2">No products in this category yet.</div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8" data-testid="shop-grid">
            {items.map((p) => <ProductCard key={p.id} product={p} />)}
          </div>
        )}
      </section>
    </div>
  );
}
